import React, { useRef } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { consumeReturnPath } from '@/utils/authRedirect';

export const PostLoginRedirect = () => {
    const location = useLocation();
    const returnPathRef = useRef<string>();

    if (!returnPathRef.current) {
        returnPathRef.current = consumeReturnPath(location.search);
    }

    return <Navigate to={returnPathRef.current} replace />;
};
